<template>

  <tr>
    <td class="text-truncate">{{ entity }}</td>
    <td class="text-truncate">{{ stauts }}</td>
    <td class="text-truncate">{{ value.total_items }}</td>
    <td class="text-truncate">{{ size }}</td>
    <td class="text-truncate">{{ author }}</td>
    <td class="text-truncate">{{ $d(new Date(value.created_at), 'short') }}</td>
    <td style="width: 160px">
      <a
        v-if="isCompleted"
        class="btn btn-block btn-sm btn-outline-primary"
        :href="value.url">
        <i class="fas fa-download" /> {{ $t('Download') }}
      </a>
      <div
        v-if="!isCompleted"
        class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          :style="{width: progress}"
          aria-valuenow="50"
          aria-valuemin="0"
          aria-valuemax="100"></div>
      </div>
    </td>
    <!-- <td class="text-truncate">
      <button
        type="button"
        class="btn btn-sm btn-light"
        @click="remove">
        <i class="fas fa-trash" />
      </button>
    </td> -->
  </tr>

</template>

<script>
import prettyBytes from 'pretty-bytes'

export default {
  name: 'Dexport',
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    }
  },
  components: {
  },
  data () {
    return {
      interval: false
    }
  },
  computed: {
    isCompleted () {
      return this.value.status === 'complete' && this.value.url
    },
    stauts () {
      return {
        complete: 'Concluído',
        pending: 'Pendente'
      }[this.value.status]
    },
    entity () {
      return {
        candidate: 'Candidato',
        job: 'Vaga'
      }[this.value.entity]
    },
    progress () {
      return Math.round(this.value.current_item / this.value.total_items * 100) + '%'
    },
    author () {
      return this.value.author_user_id ? this.value.author_user_id.name : null
    },
    size () {
      const bytes = this.value.bytes || 0
      return prettyBytes(bytes)
    }
  },
  created () {
    if (this.value.status === 'pending') {
      this.createInterval()
    }
  },
  destroyed () {
    this.removeInterval()
  },
  methods: {
    removeInterval () {
      clearInterval(this.interval)
    },
    createInterval () {
      this.interval = setInterval(() => {
        this.$store.dispatch('getDexportById', this.value._id).then(result => {
          if (result.status === 'complete') {
            this.removeInterval()
          }
        })
      }, 2000)
    },
    remove () {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteDexport', this.value._id)
        .then((result) => {
          this.loading = false
          this.$emit('removed')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dexport/DexportItem.vue